module.exports = __webpack_public_path__ + "img/proof.25559cf7.svg";